import { BaseEntity, Entity as DecribeEntity, Relation } from '@avangard/utils/entity';

import { FileInfoEntity } from '@modules/shared/entities';
import { SoaDocumentFileVariant } from '@modules/types/graphql';

import type { StudentOnlineApplicationDocumentFile } from '@modules/types/graphql';

export type Entity = Partial<StudentOnlineApplicationDocumentFile> | null;

@DecribeEntity('SoaDocumentFileEntity')
class SoaDocumentFileEntity extends BaseEntity {
    variant: SoaDocumentFileVariant;
    title: string;
    description: string | null;
    hint: string | null;
    example: string;
    uploadTitle: string;
    documentRefTitle: string;
    documentRefChosenTitle: string;
    documentRef: boolean;

    @Relation(() => FileInfoEntity)
    file: FileInfoEntity;

    // client side
    isTemplate: boolean;

    constructor(entity: Entity) {
        super(entity);

        this.variant = entity?.variant ?? SoaDocumentFileVariant.primary;
        this.title = entity?.title ?? '';
        this.description = entity?.description || null;
        this.hint = entity?.hint || null;
        this.example = entity?.example ?? '';
        this.uploadTitle = entity?.uploadTitle ?? '';
        this.documentRefTitle = entity?.documentRefTitle ?? '';
        this.documentRefChosenTitle = entity?.documentRefChosenTitle ?? '';
        this.documentRef = entity?.documentRef ?? false;

        if (entity === null) {
            this.isTemplate = true;
        }
    }

    getFileData() {
        if (!this.file.id) {
            return;
        }

        return {
            filename: this.file.name,
            fileId: this.file.id,
        };
    }
}

export { SoaDocumentFileEntity };
